<script>
    import { setupI18n, _ } from './i18n';
    import {apiRequest} from "./lib/Request.svelte";

    export let locale;
    export let comments = [];
    export let savePersonalData = false;
    export let name = null;
    export let email = null;
    export let message = null;
    export let articleId = null;

    let csrfParam = document.querySelector('meta[name="csrf-param"]').content;
    let csrfToken = document.querySelector('meta[name="csrf-token"]').content;


    setupI18n({ withLocale: locale });

    let loading = false;
    let errorMessage = '';
    let successMessage = '';

    function isValid() {
        errorMessage = '';
        if (!name || !email || !message) {
            errorMessage = $_('allFieldsAreRequiredError');
            return false;
        }

        return true;
    }

    async function saveComment() {
        const params = {
            articleId: articleId,
            name: name,
            email: email,
            message: message,
            savePersonalData: savePersonalData,
        };
        params[csrfParam] = csrfToken;
        const response = await apiRequest('post', '/blog/add-comment', JSON.stringify(params), {
            'Content-Type': 'application/json',
        });

        if (response.status === 'ok') {
            successMessage = $_('commentIsWaitingForModeration');
            setTimeout(function(){
                successMessage = '';
            }, 5000);
        }

        csrfParam = response.csrf.param;
        csrfToken = response.csrf.token;
        return response;
    }

    function onSuccess() {

    }

    async function handleClick(event) {
        if (!isValid() || loading) return;
        loading = true;

        try {
            saveComment();
        } catch (err) {
            console.log(err);
        }

        setTimeout(function(){
            loading = false;
        }, 5000);
    }

</script>


<div class="comments-widget-wrap">
    {#if errorMessage}
        <div class="alert alert-danger mb-20px">
            {errorMessage}
        </div>
    {/if}
    {#if successMessage}
        <div class="alert alert-success mb-20px">
            {successMessage}
        </div>
    {/if}
    <form class="add-comment-form-wrap mb-20px" on:submit|preventDefault={handleClick}>
        <div class="title-wrap mb-20px">{$_('addCommentTitle')}</div>
        <div class="row">
            <div class="col-md-6 mb-10px">
                <div class="form-group">
                    <input type="text" class="form-control" placeholder={$_('yourNamePlaceholder')} bind:value={name}>
                </div>
            </div>
            <div class="col-md-6 mb-10px">
                <div class="form-group">
                    <input type="text" class="form-control" placeholder={$_('yourEmailPlaceholder')} bind:value={email}>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-12 mb-20px">
                <textarea class="form-control" rows="3" placeholder={$_('messagePlaceholder')} bind:value={message}></textarea>
            </div>
        </div>
        <div class="mb-20px">
            <input type=checkbox bind:checked={savePersonalData} class="mr-10px" /> {$_('savePersonalDataCheckbox')}
        </div>
        <div class="buttons-wrap">
            <button class="btn-submit" type="submit">
                {$_('saveCommentLabel')}
                <div class="inline {loading ? '' : 'hide'}" style="vertical-align: middle;">
                    <svg class="spinner" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M23.1562 12.8438C22.6898 12.8438 22.3125 12.4664 22.3125 12C22.3125 10.6078 22.0406 9.25781 21.5016 7.98516C20.983 6.75998 20.2325 5.64659 19.2914 4.70625C18.3521 3.76387 17.2385 3.01321 16.0125 2.49609C14.7422 1.95938 13.3922 1.6875 12 1.6875C11.5336 1.6875 11.1562 1.31016 11.1562 0.84375C11.1562 0.377344 11.5336 0 12 0C13.6195 0 15.1922 0.316406 16.6711 0.944531C18.1008 1.54688 19.3828 2.41406 20.4844 3.51562C21.5859 4.61719 22.4508 5.90156 23.0555 7.32891C23.6813 8.80781 23.9977 10.3805 23.9977 12C24 12.4664 23.6227 12.8438 23.1562 12.8438V12.8438Z" fill="white"/>
                    </svg>
                </div>
            </button>
        </div>
    </form>

    {#if comments.length > 0}
    <div class="comments-wrap">
        <div class="title-wrap mb-10px">{$_('commentsListTitle')}</div>
        {#each comments as comment, i}
            <div class="comment-wrap">
                <div class="stats-wrap">
                    <span class="author-wrap">{comment.author_name}</span>
                    <span class="created-wrap">{comment.created_at}</span>
                </div>
                <div class="message-wrap">
                    {comment.message}
                </div>
            </div>
        {/each}
    </div>
    {/if}
</div>

<style>
    .inline {
        display: inline;
    }

    .mb-10px {
        margin-bottom: 10px;
    }
    .mb-20px {
        margin-bottom: 20px;
    }

    .mr-10px {
        margin-right: 10px;
    }

    .comments-widget-wrap {
        font-family: 'Montserrat', sans-serif;
    }
    .comments-widget-wrap input[type="text"], .comments-widget-wrap textarea {
        min-height: 52px;
    }
    .comments-widget-wrap input::placeholder, .comments-widget-wrap textarea::placeholder {
        font-weight: 500;
        font-size: 14px;
        line-height: 21px;
        letter-spacing: 0.02em;
        text-indent: 16px;
        color: #3B3E43;
    }
    .title-wrap {
        font-weight: 700;
        font-size: 24px;
        line-height: 32px;
        color: #212224;
    }
    .form-control {
        background: #FFFFFF;
        border: 1px solid #D8DBE1;
        border-radius: 12px;
    }

    .btn-submit {
        background: #4D89EE;
        box-shadow: 0px 15px 35px rgba(112, 155, 228, 0.65);
        border-radius: 12px;
        width: 255px;
        height: 66px;
        text-align: center;
        border-color: #4D89EE;
        color: #fff;
    }
    @-moz-keyframes spin {
        100% { -moz-transform: rotate(360deg); }
    }
    @-webkit-keyframes spin {
        100% { -webkit-transform: rotate(360deg); }
    }
    @keyframes spin {
        100% {
            -webkit-transform: rotate(360deg);
            transform:rotate(360deg);
        }
    }
    .spinner {
        -webkit-animation:spin 2s linear infinite;
        -moz-animation:spin 2s linear infinite;
        animation:spin 2s linear infinite;
    }

    .comments-wrap .created-wrap {
        font-weight: normal;
    }
    .comments-wrap .author-wrap {
        font-weight: bold;
    }
    .comments-wrap .stats-wrap {
        margin-bottom: 5px;
    }
    .comments-wrap .message-wrap {
        padding-bottom: 15px;
    }
</style>